module.exports = __webpack_public_path__ + "assets/img/Singapore Science Park.239cc636.jpg";